module.exports = __webpack_public_path__ + "img/user_icon_251290-1.9cbe0df7.png";